import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import handleHospital from "@/services/modules/hospital";
import useDate from '@/services/utils/day';
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const pdfPrinter = () => {
    const { formatDate, formatToDdMmYy } = useDate();
    const { dateOfBarthConvertToAge } = handleHospital();
    const { getHeader, getFooter } = pdfHeaderFooter();
    
    const exportToPDF = (company, notes, rxList, service, qrcode, userName, isHideHeader, isHideFooter) => { 
        const serviceResource = service.service_resource;

        var doc = {
            pageSize: 'A4',
            pageMargins: [
                serviceResource.left_margin || 25,
                serviceResource.top_margin || 170,
                serviceResource.right_margin || 25,
                serviceResource.bottom_margin || 86
            ],
            header: !isHideHeader ? getHeader(company) : {},
            footer: !isHideFooter ? getFooter(userName, qrcode) : {},
            content: getContent(doc, notes, rxList, service),
            
            styles : {
                header: {
                    fontSize: 24,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: 'Prescription- Dental'
            }
        }

        getLeftContent(doc, notes)
        getRightContent(doc, rxList)
        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (doc, notes, rxList, service) => {
        return [
            {
                columns: [
                    {
                        alignment: 'left',
                        stack: [
                            {
                                text: ''
                            }
                        ]
                        
                    },

                    {
                        alignment: 'right',
                        stack: [
                            {
                                text: ''
                            }
                        ]
                    }
                ]
            },
            
            {
                margin: [0, 10, 0, 0],
                table: {
                    widths: [90, '*', '*', 90],
                    body: [[
                        {
                            width: 90,
                            text: service.contact_profile.full_name,
                            bold: true
                        },
                        {
                            text: `ID: ${service.contact_profile.patient_id}`,
                            bold: true
                        },
                        {
                            text: `${calculateAge(service.contact_profile.birthday)} ${service.contact_profile.gender ? '| ' + capitalize(service.contact_profile.gender) : ''}`,
                            bold: true
                        },
                        {
                            text: service.doctor_order.prescription_date ? formatToDdMmYy(service.doctor_order.prescription_date, false) : formatDate(new Date(), true),
                            alignment: 'right',
                            bold: true
                        }
                    ]],
                },
                layout: {
                    hLineWidth: function (i, node) {
					    return 2;
				    },
				    vLineWidth: function (i, node) {
					    return 0;
				    }
                }
            },

            {
                columns: [
                    {
                        alignment: 'left',
                        margin: [10, 10],
                        width: '25%',
                        stack: [],
                    },
                    {
                        width: '10%',
                        text: ''
                    },
                    {
                        width: '65%',
                        stack: []
                    }
                ]
                
            },
        ]
    }

    const getRightContent = (doc, rxList) => {
        rxList.map((item) => {
            const headerName = getRightHeaderName(item);

            if (!item.selectedNotes) item.selectedNotes = [];

            if(item.selectedNotes.length > 0){
                doc.content[2].columns[2].stack.push(headerName);
            }

            var ol = [];

            item.selectedNotes.forEach((child) => {

                if (! ['rx', 'investigation'].includes(item.value)) {
                    ol.push(item.value === 'investigation_history' ? `${child.name} - ${child.result}` : child);
                    return;
                }

                if (!child.is_published) return;

                let textArray = [
                    { text: `${child.name}`, decoration: child.status === 'inactive' ? 'lineThrough' : '' },
                ];

                let text = '';
                if(child.dose) text += `${child.dose}\t`;
                if(child.unit) text += `${child.unit}\t`;
                if(child.remarks) text += `${child.remarks}\t`;
                if(child.duration) text += `${child.duration}\t`;
                if(child.result) text += `${child.result}\t`;

                if(text) textArray.push({ text: text });

                textArray.push({ text: '\n' });

                ol.push(textArray);
            })

            if (ol.length > 0) {
                doc.content[2].columns[2].stack.push({
                    ol:ol
                });
            }
        })
    }

    const calculateAge = (birthday) => {
        const { year } = dateOfBarthConvertToAge(birthday)
        return `${year}y`
    }

    const capitalize = (gender) => {
        return gender.charAt(0).toUpperCase() + gender.slice(1);
    }

    const getRightHeaderName = (item) => {
        return {
            fontSize: 14,
            bold: true,
            margin: [0, 15, 0, 5],
            text: item.name
        }
    }

    const getLeftContent = (doc, notes) => {
        notes.map((item) => {
            var phc_flag = false;
            const headerName = getLeftHeaderName(item);
            if(item.selectedNotes.length > 0){
                doc.content[2].columns[0].stack.push(headerName);
            }else if(item.value = "phc_note" && item.phcNoteText){
                doc.content[2].columns[0].stack.push(headerName);
                doc.content[2].columns[0].stack.push(JSON.parse(item.phcNoteText));
            }
            var ul = [];
            item.selectedNotes.map((child, index) => {
                if(!phc_flag){
                    let text = ((
                        item.value == 'investigation' ||
                        item.value == 'on_examinations' ||
                        item.value == 'dental_history' ||
                        item.value == 'diagnosis'
                    ) ? child.name : child) + ' \n ';

                    if (item.value === 'chief_complaint') {
                        
                        const tickCell = (hasTick, borderTop, borderRight, borderBottom, borderLeft) => ({
                            stack: [
                                {
                                    canvas: [
                                        {
                                            type: 'line',
                                            x1: 0.5, y1: 2.5,
                                            x2: 2, y2: 4,
                                            lineWidth: .8,
                                            lineColor: hasTick ? 'black' : 'white'
                                        },
                                        {
                                            type: 'line',
                                            x1: 2, y1: 4,
                                            x2: 4.5, y2: 0.5,
                                            lineWidth: .8,
                                            lineColor: hasTick ? 'black' : 'white'
                                        }
                                    ],
                                    width: 5,
                                    height: 5
                                }
                            ],
                            border: [borderLeft, borderTop, borderRight, borderBottom]
                        });

                        const cc = {
                            columns: [
                                {
                                    width: '80%',
                                    text: child,
                                    margin: [0, 0, 3, 0]
                                }
                            ],
                            margin: [0, 6, 0, 6]
                        };

                        let markedPosition = item.markedPositions && item.markedPositions.length > 0 ? item.markedPositions[index] : [];

                        if (! markedPosition || Object.values(markedPosition).every((value) => !value)) {
                            cc.columns[0].width = '100%';
                            ul.push(cc);
                            return;
                        }

                        cc.columns.push({
                            width: 12,
                            margin: [0, 2, 0, 0],
                            table: {
                                widths: [2, 2],
                                body: [
                                    [
                                        tickCell(markedPosition.first,  false, true,  true,  false),
                                        tickCell(markedPosition.second, false, false, true,  false)
                                    ],
                                    [
                                        tickCell(markedPosition.third,  false, true,  false, false),
                                        tickCell(markedPosition.fourth, false, false, false, false)
                                    ]
                                ]
                            },
                            layout: {
                                hLineWidth: () => 0.5,
                                vLineWidth: () => 0.5,
                                hLineColor: () => 'black',
                                vLineColor: () => 'black',
                            }
                        })

                        ul.push(cc);
                        return;
                    }

                    if(child.dose) text += `${child.dose} \t `;
                    if(child.unit) text += `${child.unit} \t `;
                    if(child.remarks) text += `${child.remarks} \t `;
                    if(child.duration) text += `${child.duration} \t `;
                    if(child.result) text += `${child.result} \t `;
                    if(child.dentition && child.dentition.length > 0) text += `(${child.dentition.join(', ').toUpperCase()}) \t `;

                    ul.push(text);
                }
            })
            if(!phc_flag){
                doc.content[2].columns[0].stack.push({
                    ul: ul
                })
            }
        })
    }

    const getLeftHeaderName = (item) => {
        return {
            fontSize: 14,
            bold: true,
            margin: [0, 15, 0, 5],
            text: item.name
        }
    }

    return {
        exportToPDF
    }
}

export default pdfPrinter;